import { CircularProgress } from '@mui/material';

export default () => (
  <div className="flex justify-center items-center w-full h-full">
    <CircularProgress color="secondary" />
  </div>
);
